<template>
  <nxt-core-card :class="$setClasses"
                 :title="field.title"
                 icon="calculator">
    <nxt-core-html-content v-if="!estimateLoading">
      <template v-if="computedBeforeContent"
                v-slot:beforeContent>
        <div v-html="computedBeforeContent"></div>
      </template>
      <template v-if="estimation?.volume && estimation?.distance">
        {{
          $t('estimate.message',
            {
              volume: $filters.format.convertToInteger(estimation.volume, 'm³'),
              distance: estimation.distance
            })
        }}
      </template>
      <div :class="$vClass('body')">
        <template v-if="formattedEstimate?.length"
                  :key="item.title">
          <nxt-core-card v-for="(item, index) in formattedEstimate"
                         :class="[$vClass('body__estim'),
        '--padding-none', index !== 0 && '--margin-top']">
            <div :class="[$vClass('body__estim__content'), `--${item.bg_color}`]">
              <h2 :class="$vClass('body__estim__content__title')">{{ item.title }}</h2>
              <p :class="$vClass('body__estim__content__price')">
                {{
                  $t('estimate.price', {
                    low: item.low,
                    high: item.high
                  })
                }}</p>
            </div>
            <nxt-core-toggle :initToggle="item.initInfo">
              <ul :class="$vClass('body__estim__list')">
                <template v-for="(text,i) in item.description"
                          :key="`icon-${i}`">
                  <li v-if="i > 0"
                      :class="$vClass('body__estim__list__icon')"
                  >
                    <font-awesome-icon :icon="['fal', 'circle-plus']"/>
                  </li>
                  <li :class="item.id !== 'low_estimate' && i === 0
                    && $vClass(`body__estim__list__item-important --${item.bg_color}`)">
                    {{ text }}
                  </li>
                </template>
              </ul>
            </nxt-core-toggle>
          </nxt-core-card>
        </template>
      </div>
      <template v-if="computedAfterContent"
                v-slot:afterContent>
        <div v-html="computedAfterContent"/>
      </template>
    </nxt-core-html-content>
    <div v-else>
      <nxt-core-loader :text="$t('estimate.loading')"
                       size-loader="--size-small"/>
    </div>
  </nxt-core-card>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { usePartnerStore } from '../../../store/partnerStore.ts';

export default {
  name: 'Estimate',
  nameClassStyle: 'price-card',
  props: {
    beforeContent: {
      type: String,
    },
    afterContent: {
      type: String,
    },
    field: Object,
  },
  computed: {
    ...mapState(usePartnerStore, [
      'estimateLoading',
      'estimation',
      'currentStep',
    ]),
    computedBeforeContent() {
      return this.beforeContent || this.field.before_content;
    },
    computedAfterContent() {
      return this.afterContent || this.field.after_content;
    },
    formattedEstimate() {
      this.field.value = this.estimation;
      return this.estimation?.price
        && Object.entries(this.estimation.price)
          .map((key) => ({
            ...key[1],
            ...this.$tm('estimate.formula')[key[0]],
            ...this.field.estimations[key[0]],
          }));
    },
  },
  async created() {
    try {
      if (!this.estimation?.price) {
        await this.getEstimate();
      }
    } catch (error) {
    }
  },
  methods: {
    ...mapActions(usePartnerStore, [
      'getEstimate',
    ]),
  },
};
</script>

<style lang="scss" scoped>
$colors: (
  "grey-blue": var(--nxt-color-grey-blue),
  "lynch": var(--nxt-color-lynch),
  "santas-gray": var(--nxt-color-santas-gray),
  "ghost": var(--nxt-color-ghost)
);
.#{$prefixName}price-card {
  &__body {
    margin: auto;
    padding: 20px;
    max-width: 900px;
    @include breakpoint(tablet) {
      display: flex;
      flex-flow: wrap;
      justify-content: space-around;
      &__estim {
        width: 250px;
        height: 100%;
        margin-bottom: var(--nxt-space-medium);
      }
    }

    &__estim {
      margin: auto;
      border-radius: var(--nxt-border-radius-base);
      max-width: 280px;
      width: 100%;

      &.--margin-top {
        margin-top: var(--nxt-space-default);
      }

      @include breakpoint(tablet) {
        width: 30%;
        margin: 0;
        &.--margin-top {
          margin-top: 0;
        }
      }
      @each $name, $color in $colors {
        &__content.--color-#{$name} {
          background-color: $color;
        }
        &__list__item-important.--color-#{$name} {
          color: $color;
        }
      }

      &__list__item-important {
        font-weight: var(--nxt-font-weight-bold);
      }

      &__content {
        font-weight: var(--nxt-font-weight-bold);
        background-color: var(--nxt-color-background-sub-menu-light);
        padding: var(--nxt-space-small) var(--nxt-space-xsmall);
        text-align: center;

        &__title {
          text-align: center;
          text-transform: uppercase;
          color: var(--nxt-color-white);
          font-size: 24px;
          margin: var(--nxt-space-small);
        }

        &__price {
          text-align: center;
          color: var(--nxt-color-secondary);
          white-space: normal;
          margin: var(--nxt-space-small);
          font-size: 18px;
        }
      }

      &__list {
        padding: 0 var(--nxt-space-small);
        font-size: var(--nxt-font-size-medium);
        text-align: center;
        list-style-type: none;

        &__icon {
          color: var(--nxt-color-primary);
          font-size: var(--nxt-font-size-large);
          padding: var(--nxt-space-small) 0;
        }
      }
    }
  }

  :deep(.#{$prefixName}price-card__body__notice) {
    padding-top: 20px;
    font-size: var(--nxt-font-size-medium);
  }

  :deep(.#{$prefixName}toggle) {
    padding: 0 var(--nxt-space-small);
  }
}
</style>
